import { useState } from "react";
import { CreditCard, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

/**
 * Stripe Checkout button — redirects user to Stripe's hosted checkout page.
 * Supports CB / Apple Pay / Google Pay / SEPA (auto-enabled by Stripe Dashboard).
 *
 * Props: amount, currency, donorName, donorEmail, message, anonymous, locale, t (i18n donate).
 */
const StripeCheckout = ({ amount, currency, donorName, donorEmail, message, anonymous, locale = "fr", campaignSlug, t }) => {
  const [loading, setLoading] = useState(false);

  const startCheckout = async () => {
    setLoading(true);
    try {
      // Stash donor info so /thank-you can show personalized message after Stripe redirect
      try {
        sessionStorage.setItem(
          "fcs_pending_stripe",
          JSON.stringify({
            name: anonymous ? "" : donorName,
            amount,
            currency,
            type: "one_time",
            anonymous,
          })
        );
      } catch (_) {}

      const { data } = await api.post("/stripe/checkout/session", {
        amount,
        currency,
        donor_name: donorName,
        donor_email: donorEmail,
        message: message || null,
        anonymous,
        origin_url: window.location.origin,
        locale,
        campaign_slug: campaignSlug || null,
      });
      if (data?.url) {
        window.location.href = data.url;
      } else {
        throw new Error("Missing Stripe URL");
      }
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || (t?.error || "Erreur"));
      setLoading(false);
    }
  };

  return (
    <button
      onClick={startCheckout}
      disabled={loading}
      className="w-full inline-flex items-center justify-center gap-2 py-4 rounded-lg bg-[#0A192F] hover:bg-[#001F35] text-white font-semibold text-[15px] transition-all disabled:opacity-60 shadow-[0_8px_24px_-12px_rgba(0,43,73,0.4)]"
      data-testid="stripe-checkout-btn"
    >
      {loading ? (
        <>
          <Loader2 size={18} className="animate-spin" /> {t?.stripeRedirect || "Redirection vers Stripe…"}
        </>
      ) : (
        <>
          <CreditCard size={18} className="text-[#C5A059]" />
          {t?.stripeButton || "Payer par carte / Apple Pay / Google Pay / SEPA"}
        </>
      )}
    </button>
  );
};

export default StripeCheckout;
